import React from 'react';
import { CustomModal } from '../../../../common/CustomModal';
import '../../../../../styles/components/bulk-fund-deduct-list.scss';
import { getAvatarColor, getInitials } from '../../../../../utils/common';
import { Loader2, Minus } from 'lucide-react';
import i18n from '../../../../../i18n';
import { deductFundBulk } from '../../../../../models/auctionDelivery';
import { toast } from 'react-toastify';

export class BulkFundDeductList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }
  handleSubmit = async () => {
    const { selectedRows, onSuccess, onClose } = this.props;

    if (!selectedRows || selectedRows.length === 0) {
      toast.warning(i18n.t('no_rows_selected'));
      return;
    }

    const payload = {
      items: selectedRows.map((row) => {
        const debit = Number(row.total_amount || 0);

        return {
          debit,
          auction: row.id,
          group: row.group_id,
          user: row.user_id,
        };
      }),
    };

    try {
      this.setState({ loading: true });

      const response = await deductFundBulk(payload);

      if (response?.success) {
        toast.success(response.message || 'Bulk Fund Deducted Successfully');

        if (onSuccess) onSuccess();
        else onClose();
      } else {
        toast.error(response?.message || i18n.t('failed'));
      }
    } catch (error) {
      console.error(error);
      toast.error(i18n.t('something went wrong'));
    } finally {
      this.setState({ loading: false });
    }
  };

  formatAmount = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'SAR',
      minimumFractionDigits: 2,
    }).format(Number(amount || 0));
  };

  calculateDebitAmount = (row) => {
    const serviceCharge = Number(row.service_charge || 0);
    const vatServiceCharge = Number(row.vat_service_charge || 0);

    return row.collection_type === 3
      ? serviceCharge + vatServiceCharge
      : Number(row.total_amount || 0);
  };

  render() {
    const { show, selectedRows = [], onClose } = this.props;
    const { loading } = this.state;

    return (
      <CustomModal isOpen={show} header={i18n.t('bulk_fund_deduction')} onClose={onClose}>
        <div className="bulk-deduct-container">
          {selectedRows.length === 0 ? (
            <div className="no-bulk-deduct">
              <p>{i18n.t('no_items_selected')}</p>
            </div>
          ) : (
            <div className="bulk-deduct-list">
              {selectedRows.map((row, index) => (
                <div key={row.id || index} className="bulk-deduct-card">
                  <div className="bulk-deduct-content">
                    {/* Avatar + User Info */}
                    <div className="bulk-deduct-avatar-section">
                      <div
                        className="bulk-deduct-avatar"
                        style={{ backgroundColor: getAvatarColor(row.user_id) }}
                      >
                        {getInitials(row.winner)}
                      </div>

                      <div className="bulk-deduct-info">
                        <h3 className="bulk-deduct-name">{row.winner}</h3>
                        <div className="bulk-deduct-meta">
                          <span className="bulk-deduct-meta-item">
                            {i18n.t('user_id')}: {row.user_id}
                          </span>
                          <span className="bulk-deduct-separator">•</span>
                          <span className="bulk-deduct-meta-item">
                            {i18n.t('auction')} #{row.id}
                          </span>
                          <span className="bulk-deduct-separator bulk-deduct-hide-mobile">•</span>
                          <span className="bulk-deduct-meta-item bulk-deduct-hide-mobile">
                            {i18n.t('client_bal')}: {this.formatAmount(row.client_amount)}
                          </span>
                          <span className="bulk-deduct-separator bulk-deduct-hide-tablet">•</span>
                          <span className="bulk-deduct-meta-item bulk-deduct-hide-tablet">
                            {i18n.t('paid')}: {this.formatAmount(row.paid_amount)}
                          </span>
                          <span className="bulk-deduct-separator bulk-deduct-hide-tablet">•</span>
                          <span className="bulk-deduct-meta-item bulk-deduct-hide-tablet">
                            {i18n.t('total')}: {this.formatAmount(row.total_amount)}
                          </span>
                        </div>

                        {/* Mobile-only details */}
                        <div className="bulk-deduct-details-mobile">
                          <span className="bulk-deduct-detail-item">
                            {i18n.t('client_bal')}: {this.formatAmount(row.client_amount)}
                          </span>
                          <span className="bulk-deduct-separator">•</span>
                          <span className="bulk-deduct-detail-item">
                            {i18n.t('paid')}: {this.formatAmount(row.paid_amount)}
                          </span>
                          <span className="bulk-deduct-separator">•</span>
                          <span className="bulk-deduct-detail-item">
                            {i18n.t('total')}: {this.formatAmount(row.total_amount)}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Amount Section */}
                    <div className="bulk-deduct-amount-section">
                      <div className="bulk-deduct-amount">
                        <Minus size={16} />
                        <span>{this.formatAmount(this.calculateDebitAmount(row))}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Footer */}

          {/* Action Buttons */}
          <div className="wallet-actions">
            <button type="button" className="modal-btn btn-cancel" onClick={onClose}>
              {i18n.t('cancel')}
            </button>
            <button
              type="button"
              className="modal-btn btn-confirm"
              disabled={selectedRows.length === 0}
              onClick={this.handleSubmit}
            >
              {loading ? (
                <span
                  style={{
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                  }}
                >
                  <Loader2 className="animate-spin" size={16} /> {i18n.t('deduct')}
                </span>
              ) : (
                i18n.t('deduct')
              )}
            </button>
          </div>
        </div>
      </CustomModal>
    );
  }
}
